import {Component} from "react";

function traverse(obj, path) {
  var current = obj;

  for (let part of path.split(".")) {
    if (current) {
      current = current[part];
    }
  }

  return current;
}

function checkIfMobileDevice() {
  var lowerAgent = navigator.userAgent.toLowerCase();

  return lowerAgent.indexOf("iphone") > 0 || lowerAgent.indexOf("ipod") > 0 || lowerAgent.indexOf("ipad") > 0 || lowerAgent.indexOf("android") > 0
}

function copyToClipboard(text) {
  const el = document.createElement('textarea');
  el.value = text;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
}

function trackEvent(name, category) {
  var data = {name: name, category: category};

  $.ajax({
    url: "/api/api/common/v1/tracking/event/",
    dataType: "json",
    contentType: "application/json; charset=utf-8",
    type: "POST",
    data: JSON.stringify(data)
  }).done((data, textStatus) => {
    console.log("Tracked: " + name + " in " + category);
  }).fail((jqXHR, textStatus, errorThrown) => {
    console.log("Error tracking " + name + ": " + errorThrown);
  });
}

function trackFeature(name, category) {
  var data = {name: name, category: category};

  $.ajax({
    url: "/api/api/common/v1/tracking/feature/",
    dataType: "json",
    contentType: "application/json; charset=utf-8",
    type: "POST",
    data: JSON.stringify(data)
  }).done((data, textStatus) => {
    console.log("Tracked: " + name + " in " + category);
  }).fail((jqXHR, textStatus, errorThrown) => {
    console.log("Error tracking " + name + ": " + errorThrown);
  });
}

class ErrorBoundary extends Component {
  constructor(props) {
    super();
    this.state = {hasError: false};
  }

  static getDerivedStateFromError(error) {
    // Update state to show the fallback UI during the next render phase
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // logging the error details
    console.log(`Cause: ${error}.\nStackTrace: ${info.componentStack}`);
  }

  render() {
    if (this.state.hasError) {
      // Return the fallback UI
      return <p style={{ textAlign: 'center', color: 'red' }}>Error rendering React component: {this.state.error.toString()}</p>;
    }

    return this.props.children;
  }
}


module.exports = {
  traverse: traverse,
  checkIfMobileDevice: checkIfMobileDevice,
  trackEvent: trackEvent,
  trackFeature: trackFeature,
  copyToClipboard,
  ErrorBoundary
}
